import { render, staticRenderFns } from "./MarketPreview.vue?vue&type=template&id=36692944&scoped=true&"
import script from "./MarketPreview.vue?vue&type=script&lang=js&"
export * from "./MarketPreview.vue?vue&type=script&lang=js&"
import style0 from "./MarketPreview.vue?vue&type=style&index=0&id=36692944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36692944",
  null
  
)

export default component.exports